import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["loading", "disabled", "invalid", "inline", "rightAdornment", "size", "width", "minWidth", "maxWidth", "dateInputRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { InputWrapper } from '../../../../internal/components/InputWrapper';
import { NativeTimeInput } from '../NativeTimeInput';
import * as styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var TimeInputInput = /*#__PURE__*/React.forwardRef(function TimeInputInput(props, ref) {
  var loading = props.loading,
    disabled = props.disabled,
    invalid = props.invalid,
    inline = props.inline,
    rightAdornment = props.rightAdornment,
    size = props.size,
    width = props.width,
    minWidth = props.minWidth,
    maxWidth = props.maxWidth,
    dateInputRef = props.dateInputRef,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx(InputWrapper, {
    ref: ref,
    loading: loading,
    disabled: disabled,
    inline: inline,
    invalid: invalid,
    size: size,
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth,
    className: styles['wrapper'],
    children: /*#__PURE__*/_jsx(NativeTimeInput, _objectSpread(_objectSpread({}, rest), {}, {
      ref: dateInputRef,
      className: styles['input-time']
    }))
  });
});